export enum ManualTasktemplateAccessibility {
  Basket = "Basket",
  RejectionManager = "RejectionManager",
}
